<button 
  nbButton
  ghost
  [type]="type"
  [disabled]="disabled || loading"
  [size]="size"
  [nbContextMenu]="contextMenuItems"
  [nbContextMenuTag]="contextMenuTag"
  class="pv-dropdown-action-button"
  (click)="onClick($event)">
  
  <nb-spinner 
    *ngIf="loading" 
    size="tiny" 
    status="basic">
  </nb-spinner>
  
  <nb-icon 
    *ngIf="hasIcon && !loading" 
    [icon]="icon">
  </nb-icon>
  
  <span *ngIf="hasLabel" class="button-label">{{ label }}</span>
</button>
